/**
 * GEN-2915 — escapa texto que vai entrar numa string de HTML.
 *
 * Por que existe: vários avisos do sistema são montados como `descriptionHtml` e injetados pelo
 * `CustomAlert` com `dangerouslySetInnerHTML`. Isso é conveniente para negritar um trecho, mas
 * qualquer nome vindo do banco (grupo, empresa, usuário) é **texto livre digitado por gente** —
 * interpolado cru, um nome com marcação executa na sessão de quem lê o aviso.
 *
 * Escapar no ponto de interpolação é o conserto local. O conserto de raiz é o `CustomAlert` parar
 * de aceitar HTML cru (ou escapar por padrão e receber os trechos formatados como nós React), o que
 * é card próprio: o padrão está espalhado por dezenas de telas.
 */
export const escapeHtml = (value: string | null | undefined): string =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
